import React from "react";

const Product = ({ image, title, subTitle }) => {
  return (
    <div className="flex-1 min-w-[49%] sm:max-w-[49%] max-h-[50%] sm:max-h-[45%]">
      {/* <div className="flex-1 min-w-[49%] bg-[red] max-h-[45%] "> */}
      <img
        src={image}
        alt=""
        // className="w-full max-h-[50%] h-[629px] object-cover"
        className="w-full  h-[329px] object-cover"
      />
      <div className="w-[250px] mt-4 ">
        <h4 className="text-[24px] font-[500] text-[#000]">{title}</h4>
        <h5 className="text-[16px] font-[500] text-[rgba(0,0,0,0.3)]">
          {subTitle}
        </h5>
      </div>
    </div>
  );
};

export default Product;
